import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, Card, Select, message } from 'antd';
import Input from '../../ui/Input';
import TextArea from '../../ui/TextArea';
import { LocalPersistence } from '../../../factories';
import { addLoyalty } from '../../../services/affiliations';
import PageContainer from '../../CSIComponents/PageContainer';
import Loading from '../../Loading';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import styles from '../styles.module.css';

const { Option } = Select;
const AddAward = (props: any) => {
  const travelSectorOptions = ['Air', 'Car', 'Hotel', 'Insurance', 'Golf', 'Tour', 'Rail', 'Cruise', 'Excursion', 'Ferry', 'Package Option'];
  const [form] = Form.useForm();
  const [addLoading, setAddLoading] = useState(false)
  const [disabledStatus, setDisabledStatus] = useState(true)
  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "affiliations": {
            "loyaltyprograms": [
              {
                ...value
              }
            ]
          }
        }
      }
      setAddLoading(true)
      addLoyalty(params).then(res => {
        setAddLoading(false)
        if (res.result.success) {
          setAddLoading(false)
          form.resetFields();
          props.cancelAddAndEdit();
        } else {
          message.error({
            content: res?.error[0]?.message || 'operation failed'
          });
        }
      }, err => {
        message.error({
          content: err.message || err.error[0].message
        });
        setAddLoading(false)
      });

    })
  }
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled)
      return;
    }
    form.validateFields().then(() => {
      setDisabledStatus(false)

    }).catch(() => {
      const errTotalNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;

      if (errTotalNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }

    })
  }
  if (addLoading) return <Loading type="large" />
  return (
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className='containerSpacing py-0'>
          <Grid item xs={12} className='p-0'>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>
                Loyalty Programs
              </div>
              {/* <div><Button onClick={addSave}>Edit</Button></div> */}
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              onValuesChange={(changedFields, allFields) => {
                validateFieldsError()
              }}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label='Program Name'
                    name='programname'
                    rules={[
                      {
                        max: 128,
                        message:
                          'You have reached the max character length of 128',
                      },
                    ]}>
                    <Input maxLength={128} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label='Secondary Name'
                    name='secondaryname'
                    rules={[
                      {
                        max: 65,
                        message:
                          'You have reached the max character length of 65',
                      },
                    ]}>
                    <Input maxLength={65} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Travel Sector' name='travelsector'>
                    <Select allowClear showSearch>
                      {travelSectorOptions.map((item, index) => (
                        <Option value={item} key={index}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={5}></Col>
                <Col span={6}>
                  <Form.Item label='Primary Program' name='primaryprogram'>
                    <Select allowClear showSearch>
                      <Option value={'Yes'}>Yes</Option>
                      <Option value={'No'}>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={18}>
                  <Form.Item
                    label='Restriction'
                    name='restriction'
                    rules={[
                      {
                        max: 200,
                        message:
                          'You have reached the max character length of 200',
                      },
                    ]}>
                    <TextArea maxLength={200} />
                  </Form.Item>
                </Col>
                <Col span={18}>
                  <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                      {
                        max: 4000,
                        message:
                          'You have reached the max character length of 4000',
                      },
                    ]}>
                    <TextArea maxLength={4000} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onCancel={() => {
          props.cancelAddAndEdit()
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disabledStatus}
      />
    </PageContainer>
  )
}
export default AddAward;
